/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Start_TitleInputs */

const en_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start the spell check process. Errors will appear as they are found. Correct errors while scanning is in progress.`)
};

const fr_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer la verification orthographique. Les erreurs apparaissent au fur et a mesure. Corrigez-les pendant l'analyse.`)
};

const de_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie die Rechtschreibprüfung. Fehler werden angezeigt, sobald sie gefunden werden. Korrigieren Sie Fehler während der Prüfung.`)
};

const it_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia il controllo ortografico. Gli errori appariranno man mano che vengono rilevati. Correggi gli errori durante la scansione.`)
};

const ru_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустите процесс проверки орфографии. Ошибки будут отображаться по мере их обнаружения. Исправляйте ошибки во время сканирования.`)
};

const es_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie el proceso de corrección ortográfica. Los errores aparecerán a medida que se detecten. Corrija los errores durante el proceso de escaneo.`)
};

const zh_cn2_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动拼写检查程序。错误会在发现时立即显示。扫描过程中，您可以随时更正错误。`)
};

const ja_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックプロセスを開始します。エラーが見つかった場合は表示されます。スキャン中にエラーを修正してください。`)
};

const hi_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जांच प्रक्रिया शुरू करें। त्रुटियां मिलते ही दिखाई देंगी। स्कैनिंग जारी रहने के दौरान त्रुटियों को ठीक करें।`)
};

const pt_pt2_spellcheck_start_title = /** @type {(inputs: Spellcheck_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie o processo de verificação ortográfica. Os erros aparecerão à medida que forem encontrados. Corrija os erros enquanto a verificação estiver em andamento.`)
};

/**
* | output |
* | --- |
* | "Start the spell check process. Errors will appear as they are found. Correct errors while scanning is in progress." |
*
* @param {Spellcheck_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_start_title = /** @type {((inputs?: Spellcheck_Start_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Start_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_start_title(inputs)
	if (locale === "de") return de_spellcheck_start_title(inputs)
	if (locale === "it") return it_spellcheck_start_title(inputs)
	if (locale === "ru") return ru_spellcheck_start_title(inputs)
	if (locale === "es") return es_spellcheck_start_title(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_start_title(inputs)
	if (locale === "ja") return ja_spellcheck_start_title(inputs)
	if (locale === "hi") return hi_spellcheck_start_title(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_start_title(inputs)
	return en_spellcheck_start_title(inputs)
});